import React, { useEffect, useRef, useState } from "react";
import { Text, TextInput, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import colors from "@constants/color";
import t from "@constants/localization";
import metrics from "../../../constants/metrics";
import { getData, setData } from "../../../lib/storage";
import { submitSubjectiveQuestionPoll } from "../../../services/api";

const PATH = "screens/Story";

const SubjectiveQuestion = (props) => {
  const {
    id = "",
    question = "",
    question_color = "",
    header = "",
    header_color = "white",

    pauseStory = () => {},
    unpauseStory = () => {},
    submitted,
    setSubmitted,
    trackEvent = () => {},
  } = props;

  const textInputRef = useRef(null);
  const [answer, setAnswer] = useState("");

  const onSubmit = () => {
    submitSubjectiveQuestionPoll({ pollId: id, subjectiveAnswer: answer })
      .then(async () => {
        trackEvent({ pollId: id, answerId: answer });
        setSubmitted((s) => [...s, id]);
        const submittedPolls = (await getData("cmsSubmittedPolls")) ?? [];
        await setData("cmsSubmittedPolls", [...submittedPolls, id]);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setAnswer("");
  }, [header, question]);

  return (
    <View
      style={{
        flex: 1,
        alignSelf: "center",
        position: "absolute",
        zIndex: 10,
        width: metrics.screenWidth - 80,
        left: 40,
      }}
    >
      <Text
        style={{
          fontFamily: "NotoSansDevanagari-Bold",
          color: header_color ?? "white",
          fontSize: 30,
          textAlign: "center",
          marginBottom: 10,
        }}
      >
        {header}
      </Text>
      <TouchableOpacity
        activeOpacity={0.9}
        disabled={submitted}
        onPress={() => {
          textInputRef.current?.focus();
          textInputRef.current?.focus();
          pauseStory();
        }}
        style={{
          backgroundColor: "white",
          padding: 20,
          paddingBottom: 15,
          borderRadius: 10,
          elevation: 1,
        }}
      >
        <Text
          style={{
            fontFamily: "NotoSansDevanagari-Bold",
            fontSize: 20,
            color: question_color ?? colors.primary,
            textAlign: "center",
          }}
        >
          {question}
        </Text>
        {submitted ? (
          <View
            style={{
              padding: 20,
              borderRadius: 10,
              marginBottom: 6,
              backgroundColor: "rgba(0,0,0,0.1)",
              marginTop: 40,
            }}
          >
            <Text style={{ textAlign: "center", fontSize: 18, opacity: 0.56 }}>
              {t(`${PATH}/youHaveAnswered`)}
            </Text>
          </View>
        ) : (
          <TextInput
            placeholder="यहाँ कुछ लिखें..."
            style={{
              backgroundColor: "white",
              textAlign: "center",
              borderRadius: 10,
              borderColor: "rgba(0,0,0,0.5)",
              borderWidth: 1,
              minHeight: 70,
              marginTop: 20,
              fontSize: 16,
            }}
            value={submitted ? t(`${PATH}/youHaveAnswered`) : answer}
            onChangeText={(text) => setAnswer(text)}
            ref={textInputRef}
            maxLength={140}
            multiline={true}
          />
        )}
        {typeof answer === "string" && !submitted && (
          <Text
            style={{
              marginLeft: "auto",
              marginTop: 4,
              fontSize: 12,
              color: "rgba(0, 0, 0, 0.36)",
            }}
          >{`${answer.length}/140`}</Text>
        )}
      </TouchableOpacity>
      {!submitted && (
        <TouchableOpacity
          disabled={!(!!answer && !!answer.length && !submitted)}
          onPress={onSubmit}
          style={{
            backgroundColor:
              !!answer && !!answer.length
                ? colors.primary
                : "rgba(229, 229, 229, 1)",
            marginTop: 10,
            borderRadius: 6,
          }}
        >
          <Text
            style={{
              fontFamily: "NotoSansDevanagari-Bold",
              fontSize: 16,
              color: "white",
              textAlign: "center",
              paddingVertical: 15,
              elevation: 1,
            }}
          >
            {t(`${PATH}/submit`)}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default SubjectiveQuestion;
